module.exports = __webpack_public_path__ + "img/icon_euro_bg@2x.eb221509.png";